import { Injectable } from "@angular/core";
import { PlatformService, LoggingService } from '@varsity/services';

@Injectable()
export class SecureStorageService {
    secureStorage: any = null;
    fingerprint: any = null;

    constructor(protected platformService: PlatformService,
        protected loggingService: LoggingService) {
    }

    init() {
        // https://www.npmjs.com/package/cordova-plugin-secure-storage-echo
        // https://github.com/niklasmerz/cordova-plugin-fingerprint-aio

        var promise = new Promise<boolean>((resolve, reject) => {
            if (this.fingerprint && this.secureStorage) {
                // if already done
                resolve(true);
            } else {
                this.platformService.isCordova().then((result) => {
                    this.fingerprint = (window as any).Fingerprint;
                    if (result && this.fingerprint) {
                        this.fingerprint.isAvailable((type) => {
                            this.loggingService.debug(`${type} authentication is available`);
                            var secureStorage = new (window as any).cordova.plugins.SecureStorage(
                                () => {
                                    this.loggingService.debug("secure storage is available");
                                    resolve(true);
                                    this.secureStorage = secureStorage;
                                },
                                (error) => {
                                    this.loggingService.error("unable to setup secure storage", error);
                                    reject();
                                    this.secureStorage = null;                                    
                                },
                                ""
                            );
                        }, (error) => {
                            this.loggingService.error("biometric authentication not available", error);
                            reject();
                            this.secureStorage = null;
                        });
                    }
                });
            }
        });

        return promise;
    }

    isInitialized(): boolean {
        return this.secureStorage != null;
    }

    add(key: string, value: string): Promise<any> {
        var promise = new Promise<any>((resolve, reject) => {
            if (this.secureStorage) {
                this.fingerprint.show({
                    description: "Authentication",
                    title: "Biometric",
                    disableBackup: false
                }, () => {
                    this.secureStorage.set(
                        (key) => {
                            this.loggingService.debug(`value set for '${key}'`);
                            resolve(key);
                        },
                        (error) => {
                            this.loggingService.error(`could not set value for key ${key}`, error);
                            reject();
                        },
                        key,
                        value
                    );
                }, (error) => {
                    this.loggingService.error("biometric authentication failed", error);
                    reject();
                });
            } else {
                reject("SecureStorage not initialized");
            }
        });

        return promise;
    }

    remove(key): Promise<any> {
        var promise = new Promise<any>((resolve, reject) => {
            if (this.secureStorage) {
                this.fingerprint.show({}, () => {
                    this.secureStorage.remove(
                        (key) => {
                            this.loggingService.debug(`removed value for '${key}'`);
                            resolve(key);
                        },
                        (error) => {
                            this.loggingService.error(`could not remove key '${key}'`, error);
                            reject();
                        },
                        key
                    );
                }, (error) => {
                    this.loggingService.error("biometric authentication failed", error);
                    reject();
                });
            } else {
                reject("SecureStorage not initialized");
            }
        });

        return promise;
    }

    get(key): Promise<string> {
        var promise = new Promise<any>((resolve, reject) => {
            if (this.secureStorage) {
                this.fingerprint.show({
                    description: "Authentication",
                    title: "Biometric",
                    disableBackup: false
                }, () => {
                    this.secureStorage.get(
                        (value) => {
                            this.loggingService.debug(`returned value for '${key}'`);
                            resolve(value);
                        },
                        (error) => {
                            this.loggingService.error("could not get key value", error);
                            reject();
                        },
                        key
                    );
                }, (error) => {
                    this.loggingService.error("biometric authentication failed", error);
                    reject();
                });
            } else {
                reject("SecureStorage not initialized");
            }
        });

        return promise;
    }

    clear(): Promise<any> {
        var promise = new Promise<any>((resolve, reject) => {
            if (this.secureStorage) {
                this.fingerprint.show({}, () => {
                    this.secureStorage.clear(() => {
                        this.loggingService.debug("secure storage cleared");
                        resolve();
                    }, (error) => {
                        this.loggingService.error("unable to clear secure storage", error);
                        reject(error);
                    });
                }, (error) => {
                    this.loggingService.error("biometric authentication failed", error);
                    reject();
                });
            } else {
                reject("SecureStorage not initialized");
            }
        });

        return promise;
    }

//    keys(): Promise<string[]> {
//        var promise = new Promise<string[]>((resolve, reject) => {
//            if (this.secureStorage) {
//                this.secureStorage.keys((keys) => {
//                    this.loggingService.debug("secure storage has keys", keys);
//                    resolve(keys);
//                }, (error) => {
//                    this.loggingService.error("unable to get keys from secure storage", error);
//                    reject(error);
//                });
//            } else {
//                reject("SecureStorage not initialized");
//            }
//        });

//        return promise;
//    }
}



// WEBPACK FOOTER //
// ./src/services/storage/secureStorage.service.ts